import React, { useState, useEffect } from 'react';
import './AppareilsModal.css';

/**
 * Modal "Appareils de mesure utilisés" aligné avec l'app Vercel :
 * liste des appareils de l'inspecteur avec case "Sans Objet" (non utilisés pour cette vérification).
 * Les données sont stockées dans etape_3_conditions.appareils_utilises.
 */
function AppareilsModal({ isOpen, onClose, data, onSave, mission, missionMeta }) {
  const [appareils, setAppareils] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const inspecteur = missionMeta?.inspecteur || mission?.inspecteur;
  const appareilsMesure = inspecteur?.appareils_mesure || inspecteur?.appareilsMesure;

  useEffect(() => {
    if (!isOpen) return;

    const saved = data?.appareils_utilises;
    if (Array.isArray(saved) && saved.length > 0) {
      setAppareils(saved);
      return;
    }

    if (Array.isArray(appareilsMesure) && appareilsMesure.length > 0) {
      const list = appareilsMesure.map((app, index) => ({
        id: app.id || `app_${index}_${Date.now()}`,
        fonction: app.fonction || app.designation || '—',
        marque: app.marque || '—',
        type: app.type || '—',
        sans_objet: false,
      }));
      setAppareils(list);
    } else {
      setAppareils([]);
    }
  }, [isOpen, appareilsMesure, data?.appareils_utilises]);

  const handleToggleSansObjet = (appareilId) => {
    setAppareils(prev =>
      prev.map(app =>
        app.id === appareilId ? { ...app, sans_objet: !app.sans_objet } : app
      )
    );
  };

  const handleSave = () => {
    onSave({ appareils_utilises: appareils });
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container appareil-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Appareils de mesure utilisés</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-content">
          <p className="modal-description">
            Cochez les appareils qui n'ont pas été utilisés pour cette vérification (Sans Objet).
          </p>

          {isLoading ? (
            <div className="loading-state">
              <div className="spinner-large"></div>
              <p>Chargement des appareils...</p>
            </div>
          ) : appareils.length > 0 ? (
            <div className="appareils-table-wrapper">
              <table className="appareils-table">
                <thead>
                  <tr>
                    <th>Fonction</th>
                    <th>Marque</th>
                    <th>Type</th>
                    <th className="th-sans-objet">Sans Objet</th>
                  </tr>
                </thead>
                <tbody>
                  {appareils.map((app) => (
                    <tr key={app.id}>
                      <td>{app.fonction}</td>
                      <td>{app.marque}</td>
                      <td>{app.type}</td>
                      <td className="td-checkbox">
                        <input
                          type="checkbox"
                          checked={app.sans_objet || false}
                          onChange={() => handleToggleSansObjet(app.id)}
                          aria-label="Sans objet"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-state">
              <p>
                {inspecteur
                  ? "Aucun appareil de mesure n'est défini pour cet inspecteur"
                  : "Aucun inspecteur associé à cette mission"}
              </p>
              <p className="helper-text">
                {inspecteur
                  ? "Définissez les appareils de mesure dans l'application de gestion (Paramètres → Équipe)."
                  : "Les appareils seront disponibles après synchronisation des données de la mission."}
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Annuler
          </button>
          <button className="btn btn-primary" onClick={handleSave}>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}

export default AppareilsModal;
